<template>
  <header class="phc">
    <div class="phc-top">
      <label class="phc-picker">
        <span>Provider</span>
        <v-select
          :model-value="selectedId"
          :items="providers"
          item-title="name"
          item-value="id"
          density="compact"
          variant="outlined"
          hide-details
          aria-label="Provider"
          prepend-inner-icon="mdi-magnify"
          class="phc-select"
          @update:model-value="$emit('select', $event)"
        >
          <template #item="{ props, item }">
            <v-list-item v-bind="props" />
          </template>
          <template #selection="{ item }">
            <span class="phc-sel">{{ item.title }}</span>
          </template>
        </v-select>
      </label>
      <button type="button" class="phc-add" @click="$emit('add')">+ Add provider</button>
    </div>

    <div v-if="header" class="phc-card">
      <div class="phc-avatar" aria-hidden="true">{{ initials }}</div>
      <div class="phc-info">
        <h1 class="phc-name">{{ displayName }}</h1>
        <div v-if="header.specialty" class="phc-specialty">{{ header.specialty }}</div>
        <div class="phc-row">
          <template v-if="header.npi">
            <span>NPI {{ header.npi }}</span>
            <span v-if="header.verified" class="chip chip-blue">&#10003; Verified in NPI Registry</span>
          </template>
          <template v-else>
            <span class="chip chip-amber">No NPI</span>
            <a href="#" class="phc-link" @click.prevent="$emit('add-npi')">Add NPI</a>
          </template>
        </div>
        <div v-if="header.hospital" class="phc-row">
          <span class="chip chip-blue">{{ header.hospital }}</span>
        </div>
      </div>
    </div>
    <v-skeleton-loader v-else type="list-item-avatar-two-line" class="phc-card" />
  </header>
</template>

<script>
export default {
  name: 'ProviderHeaderCard',
  props: {
    providers: { type: Array, default: () => [] },
    selectedId: { type: [Number, String], default: null },
    header: { type: Object, default: null }
  },
  emits: ['select', 'add', 'add-npi'],
  computed: {
    displayName() {
      const h = this.header || {}
      return [h.name, h.credentials].filter(Boolean).join(', ')
    },
    initials() {
      const words = String(this.header?.name || '')
        .replace(/^(dr|doctor)\.?\s+/i, '')
        .split(/\s+/)
        .filter(Boolean)
      if (!words.length) return '?'
      const first = words[0][0]
      const last = words.length > 1 ? words[words.length - 1][0] : ''
      return (first + last).toUpperCase()
    }
  }
}
</script>

<style scoped>
.phc { display: flex; flex-direction: column; gap: 12px; color: var(--brand-ink-950); }
.phc-top { display: flex; flex-wrap: wrap; justify-content: space-between; align-items: center; gap: 12px; }
.phc-picker { display: flex; align-items: center; gap: 10px; font-size: 14px; font-weight: 600; color: #33465e; }
.phc-select { min-width: 320px; background: #fff; }
.phc-add {
  height: 44px;
  padding: 0 18px;
  border: 1px solid var(--brand-ocean-600);
  background: #fff;
  color: var(--brand-ocean-600);
  border-radius: 10px;
  font: inherit;
  font-weight: 600;
  cursor: pointer;
}
.phc-add:hover { background: var(--brand-ocean-100); }
.phc-card {
  padding: 20px 28px;
  background: #fff;
  border: 1px solid #e6e1d4;
  border-radius: 12px;
  display: flex;
  gap: 16px;
  align-items: center;
}
.phc-avatar {
  width: 64px;
  height: 64px;
  flex: 0 0 auto;
  border-radius: 50%;
  background: var(--brand-ocean-100);
  color: #154b7a;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: 700;
}
.phc-info { display: flex; flex-direction: column; gap: 4px; min-width: 0; }
.phc-name { margin: 0; font-family: inherit; font-size: 28px; font-weight: 700; line-height: 1.2; }
.phc-specialty { color: #4a5568; }
.phc-row { color: #4a5568; display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.chip { font-size: 12px; font-weight: 600; padding: 3px 10px; border-radius: 999px; }
.chip-blue { background: var(--brand-ocean-100); color: #154b7a; }
.chip-red { background: #fde8e8; color: #8a1c1c; }
.chip-amber { background: var(--brand-amber-100); color: #6b4f00; }
.phc-link { font-size: 14px; font-weight: 600; color: var(--brand-ocean-600); padding: 10px 0; }
@media (max-width: 600px) {
  .phc-select { min-width: 0; width: 100%; }
  .phc-card { padding: 16px; }
  .phc-name { font-size: 22px; }
}
</style>
